/* 🤖 this file was generated by script */
export const wiconUserX01 = {
  name: 'user_x_01',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16.5 16l5 5m0-5l-5 5M12 15.5H7.5c-1.4 0-2.1 0-2.66.17a4 4 0 00-2.67 2.67C2 18.9 2 19.6 2 21M14.5 7.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z"/></svg>`,
};
